import { Response } from '@marketplace-web/core-api/api-client-util'

import { GetSellerFiltersResp } from '../types/dtos/seller-filters'

export const transformGetSellerFiltersResponse = (response: Response<GetSellerFiltersResp>) =>
  response.filters.reduce((obj, filter) => ({ ...obj, [filter.name]: filter.count }), {})
